import React, { useState } from "react";
import { Waypoint } from "react-waypoint";
const JSReveal = ({ delay, style, enter, leave, children }) => {
  const [revealed, setRevealed] = useState(true);
  const reveal = () => {
    setRevealed(true);
  };
  return (
    <Waypoint
      scrollableAncestor={typeof window !== "undefined" && window}
      onEnter={() => {
        reveal();
        enter && enter();
      }}
      onLeave={() => {
        leave && leave();
      }}
    >
      <div
        // className={ClassNames(
        //   s.jsReveal,
        //   { [s.isRevealed]: revealed },
        //   { [s.delay]: delay }
        // )}
        style={style}
      >
        {children}
      </div>
    </Waypoint>
  );
};

export default JSReveal;
